import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";

export default {
  path: "/user",
  redirect: "/user",
  name: "User",
  component: LAYOUT,
  meta: {
    title: "用户",
    hideMenu: true,
  },
  children: [
    {
      path: "",
      name: "UserPage",
      component: () => import("../../views/user/UserPage.vue"),
      meta: {
        title: "用户中心",
        hideMenu: true,
      },
    },
  ],
} as RouteRecordRaw;
